import React from 'react';
import styles from './AboutUsTeam.module.scss';

const builds = [
    {
        badge: 'LIVE NOW',
        badgeClass: 'badgeLive',
        borderClass: 'borderLive',
        title: 'Build 0.1',
        leftItems: [
            '1,200+ practice questions across all 8 SAT topics',
            "Instant AI explanations when you're stuck",
            'Progressive hints system',
        ],
        rightItems: [
            'Adaptive testing environment that learns with you',
            'Progress tracking & visualization',
        ],
    },
    {
        badge: 'IN DEVELOPMENT',
        badgeClass: 'badgeDev',
        borderClass: 'borderDev',
        title: 'Build 0.2',
        leftItems: [
            'Full-length diagnostic test (two-module structure)',
            'Enhanced goal setting & test date countdown',
        ],
        rightItems: [
            'Score prediction based on your practice performance',
            'Note-taking feature within practice sessions',
        ],
    },
    {
        badge: 'ON THE HORIZON',
        badgeClass: 'badgeHorizon',
        borderClass: 'borderHorizon',
        title: 'Build 0.3+',
        leftItems: [
            'Personalized study plans based on your data',
            'Advanced mistake tracking with reflection prompts',
        ],
        rightItems: [
            'Weekly progress reports to parents/guardians',
            'Vetted tutor marketplace with 1-on-1 video sessions',
        ],
    },
];

const AboutUsTeam = () => {
    return (
        <section className={styles.section}>
            <div className={styles.contentWrapper}>
                <h2 className={styles.heading}>Prepal is only starting. Grow with us.</h2>
                <div className={styles.buildList}>
                    {builds.map((build, i) => (
                        <div key={i} className={`${styles.buildCard} ${styles[build.borderClass]}`}>
                            <div className={styles.buildHeader}>
                                <span className={`${styles.badge} ${styles[build.badgeClass]}`}>{build.badge}</span>
                                <span className={styles.buildTitle}>{build.title}</span>
                            </div>
                            <div className={styles.featureGrid}>
                                <ul className={styles.featureList}>
                                    {build.leftItems.map((item, j) => (
                                        <li key={j} className={styles.featureItem}>{item}</li>
                                    ))}
                                </ul>
                                <ul className={styles.featureList}>
                                    {build.rightItems.map((item, j) => (
                                        <li key={j} className={styles.featureItem}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
                <a href="/pricing" className={styles.ctaButton}>
                    Join as a Founding Member
                </a>
            </div>
        </section>
    );
};

export default AboutUsTeam;
